import { yup } from '@guiker/yup-util'

export const readAllCategoriesQueryParams = yup.object({
  _embed: yup.boolean().default(true),
  orderby: yup.string().default('id'),
  order: yup.string().oneOf(['asc', 'desc']).default('asc'),
  page: yup.number().min(1).default(1),
  per_page: yup.number().min(1).max(100).default(100),
})
